<template>
  <div class="pt-16 bg-slate-100">
    <div
      class="fixed left-0 z-20 flex items-center justify-between flex-grow h-16 gap-4 px-6 border-b top-18 bg-slate-300 border-slate-400"
      :style="{ minWidth: 'calc(100vw - 0.5rem)' }"
    >
      <div class="sticky top-18 left-6">
        <BlTextTitle4 text="Edit Pipeline" />
      </div>
      <div class="sticky flex items-center gap-2 top-18 right-6">
        <BlInputButton label="Add new stage" @clicked="onCreateNewStage(2)" />
        <BlInputButton type="plain" label="Close" @clicked="backToBoard" />
      </div>
    </div>
    <div v-if="pageLoading" class="grid w-full h-92 place-items-center">
      <div class="blum-loader"></div>
    </div>
    <draggable
      v-else
      handle=".handle_move_position"
      @update.prevent="onMovePosition($event)"
      class="flex gap-6 px-10 pt-3 pb-1"
    >
      <div v-for="(stage, idx) in stages" :key="stage.id" class="relative flex">
        <div
          v-if="!stage.is_discontinued && stage.position !== 1"
          class="absolute flex flex-col items-center w-6 gap-2 pt-4 pb-2 transition-all duration-300 opacity-0 -left-6 hover:opacity-100"
          :class="[createLoading ? 'cursor-wait' : 'cursor-pointer']"
          :style="{ height: 'calc(100vh - 10rem)' }"
          @click="onCreateNewStage(idx + 1)"
        >
          <div
            class="flex items-center justify-center flex-shrink-0 w-6 h-6 border rounded-full border-slate-400 bg-pure-white"
          >
            <BlIcon icon="plus" color="slate-6" class="w-4 h-4" />
          </div>
          <div class="flex-grow w-1 rounded bg-slate-500"></div>
        </div>
        <PipelineStage :stage="stage" editable />
      </div>
      <div class="flex-shrink-0 w-px"></div>
    </draggable>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import draggable from "vuedraggable";

import PipelineStage from "./pipeline/Stage.vue";

import BlTextTitle4 from "../BlTextTitle4.vue";
import BlInputButton from "../BlInputButton.vue";
import BlIcon from "../BlIcon.vue";

export default {
  name: "ClientAcquisition",
  components: {
    draggable,
    PipelineStage,
    BlTextTitle4,
    BlInputButton,
    BlIcon
  },
  data() {
    return {
      pageLoading: true,
      createLoading: false
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter", "stages"])
  },
  mounted() {
    const app = document.getElementById("app");
    if (app) {
      app.classList.add("bg-slate-100");
      app.classList.remove("bg-slate-200");
    }
    if (!this.currentUser.role.includes("admin")) {
      return this.$router.push({ name: "Clients" });
    }
    if (!this.currentCenter.enable_sales_pipeline) {
      return this.$router.push({ name: "Clients" });
    }
    this.fetchStages();
  },
  destroyed() {
    const app = document.getElementById("app");
    if (app) {
      app.scroll({ top: 0, left: 0 });
      app.classList.remove("bg-slate-100");
      app.classList.add("bg-slate-200");
    }
  },
  methods: {
    ...mapActions([
      "getStages",
      "getStageProspectStages",
      "createStage",
      "updateStage",
      "showToast"
    ]),
    fetchStages() {
      if (this.$route.path !== "/client-acquisition/edit") return;

      this.pageLoading = true;
      this.getStages().then(async () => {
        this.pageLoading = false;
      });

      // sync url path for page
      const incomingPath = `/client-acquisition/edit`;
      if (this.$route.fullPath !== incomingPath) {
        return this.$router.push(incomingPath);
      }
    },
    backToBoard() {
      this.$router.push({ name: "ClientAcquisition" });
    },
    onCreateNewStage(position) {
      if (this.createLoading) return;
      const data = {
        stage: {
          name: "New stage",
          description: "",
          position
        }
      };
      this.createLoading = true;
      this.createStage(data).then(({ success }) => {
        this.createLoading = false;
        if (!success) return;
        this.getStages().then(({ data: stages }) => {
          stages.forEach(stage => {
            this.getStageProspectStages({ id: stage.id });
          });
        });
      });
    },
    onMovePosition(event) {
      const newPosition = event.newIndex + 1;
      const stage = this.stages[event.oldIndex];
      const data = {
        id: stage.id,
        stage: { position: newPosition }
      };
      if (newPosition === 1) {
        const title = `Stage update failed`;
        const message = `Failed! The stage could not be moved to the first position.`;
        this.showToast({ title, message, type: "error" });
        return this.fetchStages();
      }
      const admittedPos = this.stages.length - 2;
      if (newPosition >= admittedPos) {
        const title = `Stage update failed`;
        const message = `Failed! The stage could not replace the <b>Admitted</b>, <b>Pending</b>, or <b>Discontinued</b> positions.`;
        this.showToast({ title, message, type: "error" });
        return this.fetchStages();
      }
      this.updateStage(data).then(({ success }) => {
        if (!success) return;
        const title = `Stage updated`;
        const message = `Success! The stage position has been updated.`;
        this.showToast({ title, message, type: "success" });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/salesPipeline/EditPipeline.vue